import { createSelector } from '@ngrx/store';
import { getSEOState } from '../feature.selector';
import { SeoState } from '../state';

export const getPlpSeoContent = createSelector(
  getSEOState,
  (state: SeoState) => state.plpSeo.plpSEOContent
);
